<template>
  <div v-show="show" ref="tab" role="tabpanel">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch, getCurrentInstance } from "vue";

const tab = ref();

const show = ref(true);
const instance = getCurrentInstance();

watch(
  //@ts-expect-error
  () => instance.parent?.exposed.activeTab.value,
  (newV) => {
    if (newV !== undefined) {
      if (newV?.key === instance?.vnode.key) {
        show.value = true;
      } else {
        show.value = false;
      }
    }
  },
);

defineExpose({
  tab,
  show,
});
</script>

<style></style>
